import { PageInfo } from 'src/assets/types/interface/page-info.interface';
import { firstValueFrom } from 'rxjs';
import { DemandService } from 'src/app/services/apps/demand/demand.service';

export async function buildDemandPageInfo(
  demandUuid: string,
  demandService: DemandService,
): Promise<PageInfo> {
  try {
    const demand = await firstValueFrom(
      demandService.getDemandByUuid(demandUuid),
    );
    return {
      identification: demand.local_number ?? '',
      title: 'Solicitação: ',
      pagesAbove: [
        {
          title: 'Solicitações de Serviço',
          url: '/gestao/solicitacoes',
          description: 'Listagem das solicitações de serviço',
        },
      ],
    };
  } catch (err) {
    console.error('Erro ao buscar detalhes da solicitação:', err);
    return { identification: '', title: 'Solicitação: ', pagesAbove: [] };
  }
}
